import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity, AlertCircle, CheckCircle2, Clock } from 'lucide-react';

interface ProcessingStats {
  total: number;
  pending: number;
  partial: number;
  unmatched: number;
  success: number;
}

interface ProcessingQueueHeaderProps {
  stats: ProcessingStats;
}

export function ProcessingQueueHeader({ stats }: ProcessingQueueHeaderProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Activity className="h-4 w-4" />
              Total
            </div>
            <div className="text-2xl font-bold">{stats.total}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              Pending
            </div>
            <div className="text-2xl font-bold">{stats.pending}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-warning">
              <AlertCircle className="h-4 w-4" />
              Partial
            </div>
            <div className="text-2xl font-bold text-warning">{stats.partial}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-blue-500">
              Unmatched
            </div>
            <div className="text-2xl font-bold text-blue-500">{stats.unmatched}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-success">
              <CheckCircle2 className="h-4 w-4" />
              Parsed
            </div>
            <div className="text-2xl font-bold text-success">{stats.success}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
